export class URLUtilities {
  /**
   * A method to combine a base URL with a path.
   * It handles slashes between the base and the path.
   * If base is empty, it will throw an error as it is not a valid URL.
   * */
  public static combine(basePath: string, path: string): URL {
    let safeBasePath = basePath;
    let safePath = path;
    if (safeBasePath.endsWith('/')) {
      safeBasePath = safeBasePath.replace(/\/+$/, '/');
    } else {
      safeBasePath += '/';
    }
    if (safePath.startsWith('/')) safePath = safePath.replace(/^\/+/, '');
    const baseURL = new URL(safeBasePath);
    return new URL(safePath, baseURL);
  }

  public static isUrlValid(url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch (err) {
      return false;
    }
  }
}
